<template>
  <header
    class="fixed top-0 left-1/2 mt-10 transform -translate-x-1/2 z-50 w-[90%] max-w-screen-sm lg:w-[40%] bg-black/50 backdrop-blur-md shadow-lg rounded-full border-none transition-transform duration-300 ease-in-out"
  >
    <nav class="relative flex items-center justify-center py-3 lg:flex" aria-label="Main Navigation">
      <ul class="flex space-x-6 md:space-x-8">
        <li v-for="link in links" :key="link.id">
          <a
            href="#"
            @click.prevent="scrollToSection(link.id)"
            class="relative font-medium text-[#e4ac3b] hover:text-white transition-all cursor-pointer"
            :class="{ 'text-white font-semibold': activeSection === link.id }"
          >
            {{ link.text }}
            <span
              v-if="activeSection === link.id"
              class="absolute left-1/2 transform -translate-x-1/2 bottom-[-6px] h-[3px] w-3/4 bg-[#e4ac3b] rounded-full transition-all"
            ></span>
          </a>
        </li>
      </ul>
    </nav>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";

const activeSection = ref(""); // Track the active section
const links = [
  { text: "Home", id: "hero" },
  { text: "About", id: "about" },
  { text: "Products", id: "products" },
  { text: "Services", id: "services" },
  { text: "Partners", id: "partners" },
  { text: "Contact Us", id: "contact-us" },
];

// Function to scroll to a section smoothly
const scrollToSection = async (id) => {
  await nextTick(); // Ensure elements are rendered before scrolling

  const section = document.getElementById(id);
  if (section) {
    window.scrollTo({
      top: section.offsetTop - 80, // Offset for fixed navbar
      behavior: "smooth",
    });

    // Update active section immediately
    activeSection.value = id;
  }
};

// Function to update the active section on scroll
const updateActiveSection = () => {
  const scrollPosition = window.scrollY + 200; // Adjust offset for better detection

  for (const link of links) {
    const section = document.getElementById(link.id);
    if (section) {
      const { offsetTop, offsetHeight } = section;
      if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
        activeSection.value = link.id;
        break;
      }
    }
  }
};

onMounted(() => {
  window.addEventListener("scroll", updateActiveSection);
  updateActiveSection(); // Call once to set initial state
});

onUnmounted(() => {
  window.removeEventListener("scroll", updateActiveSection);
});
</script>